import { render, staticRenderFns } from "./slideShow.vue?vue&type=template&id=4685d2f0&scoped=true"
import script from "./slideShow.vue?vue&type=script&lang=js"
export * from "./slideShow.vue?vue&type=script&lang=js"
import style0 from "./slideShow.vue?vue&type=style&index=0&id=4685d2f0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4685d2f0",
  null
  
)

export default component.exports